<template>
  <div>
    <DropdownActionItem class="flex items-center" data-test-id="request-recommendation" @click="startEditing">
      Request a <br class="inline-block md:hidden" /> recommendation
    </DropdownActionItem>
    <Modal
      ref="SendMessageModal"
      v-model="messageBody"
      :show="isEditing"
      :athlete-name="athleteName"
      data-test-id="feedback-request-modal"
      @confirm="onEditConfirm()"
      @close="onEditCancel()"
    />
  </div>
</template>

<script>
import Modal from '@/components/FeedbackRequest/Modal'
import commaAnd from '@/utils/commaAnd'
import { subject } from '@/utils/pronouns'
import { DropdownActionItem } from "@sportsrecruits/playbook"
import { mapActions, mapGetters } from "vuex";
import uniqBy from "lodash/uniqBy";

export default {
  name: "FeedbackRequestActionItem",
  components: { DropdownActionItem, Modal },
  data() {
    return {
      messageBody: '',
      isEditing: false,
    }
  },
  computed: {
    ...mapGetters('athleteProfile', {
      athleteName: 'firstName',
      organizations: 'organizations',
      teams: 'teams',
      athleteGender: 'gender',
    }),

    ...mapGetters('userData', {
      coachName: 'firstName',
    }),

    chosenOrganization() {
      return this.organizations[0]
    },

    staves() {
      return uniqBy([
        ...this.chosenOrganization.staff.filter(staff => staff.isAdmin),
        ...this.teams.filter(team => team.organization.id === this.chosenOrganization.id)
          .map(team => team.staffAffiliations)
          .reduce((allStaves, affiliations) => {
            return [
              ...allStaves,
              ...affiliations.map(a => a.staff),
            ]
          }, []),
      ], 'id')
    },

    staffNames() {
      return this.staves.map(staff => staff.firstName)
    },

    defaultMessage() {
      return this.makeMessageBody({
        coachName: this.coachName,
        athleteName: this.athleteName,
        athleteGender: this.athleteGender,
        staffNames: this.staffNames,
        domainName: this.$domain.config('title_name'),
      }).replace(/^\n/, '')
        .replace(/^(\t| )+/gm, '')
        .replace(/[^\n]\n[^\n]/gm, s => s.replace('\n', ' '))
        .replace(/\n+$/, '');
    },
  },
  created() {
    this.resetMessage()
  },
  methods: {
    ...mapActions('athleteProfile', ['sendFeedbackRequest']),

    async send() {
      await this.sendFeedbackRequest({
        type: 'general',
        body: this.messageBody,
        organization: this.chosenOrganization,
        source: this.source,
      })
    },

    makeMessageBody: ({ coachName, athleteName, athleteGender, staffNames, domainName }) => `
        Hi ${commaAnd(staffNames)},

        I just viewed ${athleteName}'s profile on ${domainName}
        and am interested in learning more about ${athleteName} as a student-athlete.
        Do you think ${subject(athleteGender)} is a good fit for our program?
        Please reply with any additional info that you feel would be valuable for our evaluation.

        Thanks,

        ${coachName}
      `,

    startEditing() {
      this.isEditing = true
    },
    onEditConfirm() {
      this.send()
      this.isEditing = false
    },

    onEditCancel() {
      this.resetMessage()
      this.isEditing = false
    },

    resetMessage() {
      this.messageBody = this.defaultMessage
    },
  },
}
</script>
